"use strict";

var _ = require('underscore');

module.exports = {
    fetchRelation: function (/* relation1, relation2, ..., options */) {
        var lastArg = arguments[arguments.length - 1];
        var relations = [].slice.call(arguments);
        var options = {};

        if (_.isObject(lastArg)) {
            relations.pop();
            options = lastArg;
        }

        options.data = options.data || {};
        options.data.fields = options.data.fields || relations.join(',');

        return this.fetch(options);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/mixins/fetchRelation.js
// module id = 2654
// module chunks = 63